import Box from "@mui/material/Box";
import { Conversation, Participant } from "../../stores/ChatClientStore";
import useChatClient from "../../hooks/useChatClient";
import AvatarGroup from "@mui/material/AvatarGroup";
import Avatar from "@mui/material/Avatar";
import { ReactNode, useMemo } from "react";
import Typography from "@mui/material/Typography";
import { useAuth } from "../../../../hooks/useAuth";
import Button from "@mui/material/Button";

type Props = {
    cn: Conversation
}

function stringToColor(string: string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
}

function stringAvatar(name: string) {
    if (name.split(' ').length < 2) {
        return {
            sx: {
                width: 34, height: 34,
                bgcolor: stringToColor(name),
            },
            children: `${name.split(' ')[0][0]}${name.split(' ')[0][1]}`,
        };
    }

    return {
        sx: {
            width: 34, height: 34,
            bgcolor: stringToColor(name),
        },
        children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
    };
}

const renderAvatars = (p: Participant[]) => {
    const nodes = [] as ReactNode[]

    for (let i = 0; i < p.length && i < 3; i++) {
        nodes.push(<Avatar {...stringAvatar(p[i].userFullName)} />)
    }

    return nodes;
}

const renderNames = (p: Participant[]) => {
    return p.flatMap(s => s.userFullName).join(', ');
}

const ConversationSummary = ({ cn }: Props) => {
    const { user } = useAuth();
    const {
        setSelectedConversation
    } = useChatClient();

    const hasJoined = useMemo(() => {
        return cn.participants.some(s => s.userEmail === user?.email);
    }, [cn])

    return (
        <Box onClick={() => setSelectedConversation(cn)}>
            <Box display='flex' alignItems='center' gap={2}>
                <AvatarGroup total={cn.participants.length}>
                    {renderAvatars(cn.participants)}
                </AvatarGroup>

                <Box>
                    <Typography noWrap display='flex' justifyContent='space-between'>
                        {renderNames(cn.participants)}                        
                    </Typography>
                    <Typography noWrap variant='subtitle1'>
                        {cn.detectedIntent} ({(cn.score * 100).toFixed(0)}%)
                    </Typography>
                </Box>
            </Box>
        </Box>
    )
}

export default ConversationSummary;